/**
 * Signing out of Gyro on the web (appKey "web" on gyro.gyro360.ai; docs/PLAN-web-gyro-gyro360.md): Gyro's own session first
 * (POST /auth/logout on the page's origin), then Cloudflare Access's, at the path gyro-svc names in its answer
 * (`accessLogout`, auth.ts). Only Access's own logout path on this origin is followed; any other answer goes to the page's
 * root, which sends a signed-out browser to sign in again.
 *
 * When Gyro's sign-out does not finish (no network, an error answer) nothing navigates: the session is still there, so the
 * caller says so and the person can try again, rather than a reload that looks signed out and is not.
 */
export const ACCESS_LOGOUT_PATH = '/cdn-cgi/access/logout';
export async function signOutOfGyroWeb(deps) {
    let res;
    try {
        res = await (deps.fetchImpl ?? fetch)(`${deps.baseUrl}/auth/logout`, { method: 'POST', credentials: 'include' });
    }
    catch {
        return 'failed';
    }
    if (!res.ok)
        return 'failed';
    const body = (await res.json().catch(() => null));
    deps.assign(body?.accessLogout === ACCESS_LOGOUT_PATH ? ACCESS_LOGOUT_PATH : '/');
    return 'signed-out';
}
//# sourceMappingURL=webSignOut.js.map